export default function ZoneAbattagesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('zone.abattages');
}

ZoneAbattagesConfiguration.$inject = ['$translatePartialLoaderProvider'];
